import { connect } from 'react-redux';
import {
  dailyBlotterColumnsRequested,
  dailyBlotterQuotesRequested,
} from 'state/blotters/dailyBlotter/dailyBlotter.action';
import { getDailyBlotterPaginationInfo } from 'state/blotters/dailyBlotter/dailyBlotter.selectors';
import { getStaticFormInfos } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

interface StateProps {
  isDailyBlotterTabActive: boolean;
  page: number;
}

interface DispatchProps {
  onQuoteRequested: (page: number) => void;
  onColumnsRequested: () => void;
}

export type DailyBlotterState = StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => {
  const tabId = getWorkspaceActiveTabId(state, 'static')!;
  const isDailyBlotterTabActive = getStaticFormInfos(state, tabId)!.formActiveTab === 'DailyBlotterTab';

  const { page } = getDailyBlotterPaginationInfo(state);

  return {
    isDailyBlotterTabActive,
    page,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  onQuoteRequested(pageIndex) {
    dispatch(dailyBlotterQuotesRequested(pageIndex));
  },
  onColumnsRequested() {
    dispatch(dailyBlotterColumnsRequested());
  },
});

export const connectDailyBlotter = connect(mapStateToProps, mapDispatchToProps);
